import { type AlpineComponent } from "alpinejs"

type ArtsDonationFormComponent = AlpineComponent<{
  donationOption: number | "one-off-donation" | null
  subscriptionIntervalOption: "month" | "year" | null
  oneOffOption: number | "enter-your-own-amount" | null
  oneOffCustomAmount: number | null
  subscriptionAmount: number
  oneOffAmount: number
  focusOneOffCustomAmountInputEl(): void
  handleOneOffCustomAmountInput(e: Event): void
  donationAmount(): number
  deductibleTaxAmount(): number
  totalDueAmount(): number
  formatAmount(amount: number): string
}>

export default function artsDonationForm(): ArtsDonationFormComponent {
  return {
    donationOption: null,
    subscriptionIntervalOption: null,
    oneOffOption: null,
    oneOffCustomAmount: 0,
    subscriptionAmount: 0,
    oneOffAmount: 0,

    init() {
      this.$watch("donationOption", value => {
        if (!value) return

        if (value === "one-off-donation") {
          if (this.oneOffOption === "enter-your-own-amount") {
            this.oneOffAmount = this.oneOffCustomAmount || 0
            this.focusOneOffCustomAmountInputEl()
          } else {
            this.oneOffAmount = this.oneOffOption || 0
          }

          return
        }

        this.subscriptionAmount =
          this.subscriptionIntervalOption === "month" ? value / 12 : value
      })

      this.$watch("subscriptionIntervalOption", value => {
        if (
          !value ||
          !this.donationOption ||
          this.donationOption === "one-off-donation"
        )
          return

        this.subscriptionAmount =
          value === "month" ? this.donationOption / 12 : this.donationOption
      })

      this.$watch("oneOffOption", value => {
        if (!value) return

        if (value === "enter-your-own-amount") {
          this.oneOffAmount = this.oneOffCustomAmount || 0
          this.focusOneOffCustomAmountInputEl()
          return
        }

        this.oneOffAmount = value
      })

      this.$watch("oneOffCustomAmount", value => {
        if (!value) return

        const oneOffCustomAmountHiddenInputEl = this.$refs
          .oneOffCustomAmountHiddenInputEl as HTMLInputElement
        oneOffCustomAmountHiddenInputEl.value = value.toString()
        oneOffCustomAmountHiddenInputEl.dispatchEvent(new Event("change"))

        this.oneOffAmount = value
      })
    },
    focusOneOffCustomAmountInputEl() {
      this.$nextTick(() => this.$refs.oneOffCustomAmountInputEl.focus())
    },
    handleOneOffCustomAmountInput(e) {
      const { value } = e.target as HTMLInputElement
      this.oneOffCustomAmount = parseInt(value.replace(/,/g, "")) || 0
    },
    donationAmount() {
      const donationAmount =
        this.donationOption === "one-off-donation"
          ? this.oneOffAmount
          : this.donationOption

      return donationAmount || 0
    },
    deductibleTaxAmount() {
      return this.donationAmount() * 0.33
    },
    totalDueAmount() {
      const totalDueAmount =
        this.donationOption === "one-off-donation"
          ? this.oneOffAmount
          : this.subscriptionAmount

      return totalDueAmount
    },
    formatAmount(amount: number) {
      return amount.toLocaleString("en-NZ", {
        style: "currency",
        currency: "NZD",
      })
    },
  }
}
